<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">核算月份</div>
          <el-date-picker
            class="ipt-sty"
            size="mini"
            v-model="page.accountMonth"
            @change="onChangeAccountMonth"
            type="month"
            align="center"
            range-separator="-"
            placeholder="请选择月份"
            value-format="yyyy-MM"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">原接包公司</div>
          <el-select
            @change="onChangeTenant"
            v-model="page.tenantGuid"
            placeholder="请选接包公司"
            class="ipt-sty"
            filterable
            size="mini"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">原任务包</div>
          <el-select
            v-model="page.taskGuid"
            placeholder="请选择原任务包"
            class="ipt-sty"
            filterable
            size="mini"
          >
            <el-option
              v-for="item in taskPackageMap[page.tenantGuid]"
              :key="item.guid"
              :label="item.taskTitle"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button
            size="mini"
            type="text"
            @click="onChangeShowMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? "收起筛选" : "更多筛选" }}
          </el-button>
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch"
            >清空</el-button
          >
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div" style="margin-left: 30px">状态</div>
          <el-select
            v-model="page.changeTypeList"
            filterable
            placeholder="请选择"
            class="ipt-sty"
            size="mini"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in ChangeTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">新接包公司</div>
          <el-select
            @change="onChangeNewTenant"
            v-model="page.changeTenantGuid"
            placeholder="请选新接包公司"
            class="ipt-sty"
            filterable
            size="mini"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">新任务包</div>
          <el-select
            v-model="page.changeTaskGuid"
            filterable
            placeholder="请选择新任务包"
            class="ipt-sty"
            size="mini"
          >
            <el-option
              v-for="item in taskPackageMap[page.changeTenantGuid]"
              :key="item.guid"
              :label="item.taskTitle"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">提交人</div>
          <el-input
            size="mini"
            v-model="page.createUserName"
            class="fl"
            placeholder="请输入名称"
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <div
      class="back-color-fff content-main-box"
      :style="'height:' + contentMainHeight + 'px;'"
    >
      <el-table
        :data="tableData"
        :height="tableHeight"
        stripe
        border
        style="width: 100%"
      >
        <el-table-column
          fixed="left"
          label="序号"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="left"
          prop="taskTitle"
          width="320"
          label="原任务包"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            <a
              class="txt-color"
              @click="goToTaskDeliverDetail(scope.row.taskGuid)"
            >
              {{ scope.row.taskTitle || "-" }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          width="200"
          label="原接包公司"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.tenantName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="organisationName"
          width="200"
          label="原接包组织"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.organisationName || "-" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="changeType"
          width="120"
          label="状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span :style="ChangeTypeMap[scope.row.changeType]?.style">
              {{ ChangeTypeMap[scope.row.changeType]?.text || "-" }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="changeTaskTitle"
          width="320"
          label="新任务包"
          show-overflow-tooltip
          header-align="center"
        >
          <template slot-scope="scope">
            <a
              class="txt-color"
              @click="goToTaskDeliverDetail(scope.row.changeTaskGuid)"
            >
              {{ scope.row.changeTaskTitle || "-" }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          prop="changeTenantName"
          width="200"
          label="新接包公司"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.changeTenantName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="changeOrganisationName"
          width="200"
          label="新接包组织"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.changeOrganisationName || "-" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="errorInfo"
          width="220"
          label="失败原因"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.errorInfo || "-" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="useSecond"
          width="120"
          label="处理耗时(秒)"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.useSecond || "-" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="createUserName"
          width="120"
          label="提交人"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.createUserName || "-" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          width="200"
          label="提交时间"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime | getTimeDate }}
          </template>
        </el-table-column>

        <el-table-column
          prop="endTime"
          width="200"
          label="完成时间"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.endTime | getTimeDate }}
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="120"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              v-if="showRevokeBtn(scope.row)"
              @click="handleRevoke(scope.row)"
            >
              撤销
            </el-button>

            <el-button
              type="text"
              size="mini"
              v-if="showRestartBtn(scope.row)"
              @click="handleRestart(scope.row)"
            >
              重试
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
  </div>
</template>

<script>
import { ChangeTypeEnum, ChangeTypeList, ChangeTypeMap } from "./enum";

export default {
  data() {
    return {
      ChangeTypeEnum,
      ChangeTypeList,
      ChangeTypeMap,
      fullscreenLoading: false,
      tableHeight: window.innerHeight - 213,
      contentMainHeight: window.innerHeight - 213,
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        accountMonth: "", // 时间范围
        tenantGuid: "", //企业GUID
        taskGuid: "", //任务包GUID
        changeTenantGuid: "", //接包企业GUID
        changeTaskGuid: "", //接包任务包GUID
        changeTypeList: [], //转换类型 0待处理 1转换中 2转换成功 3转换失败 4撤消中 5撤销成功 6撤销失败
        createUserName: "", //创建人姓名
      },
      tableData: [],
      tenantList: [], // 企业列表 原接包公司列表 新接包公司列表
      taskPackageMap: {}, // 任务包列表 原任务包列表 新任务包列表
    };
  },
  methods: {
    goToTaskDeliverDetail(guid) {
      this.$router.push({
        path: "/taskDeliverDetail",
        query: {
          guid: guid,
        },
      });
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.getData();
    },
    // 任务包
    async getList(val) {
      if (!this.page.accountMonth) {
        this.$message.error("请选择核算月份");
        return;
      }
      const accountMonth = this.page.accountMonth?.replace("-", "");
      const params = {
        pageIndex: 1,
        pageSize: -1,
        lockStatus: 0, // 0 未锁定 1 已锁定
        isChangeService: "Y",
        approvalState: ["Y"],
        accountMonth: accountMonth,
        serviceTenantGuid: val,
        isShowTest: true,
        isExcludeDataPermission: true,
        onlyMyData: false,
        state: ["已派发"],
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/task/data/get-list`,
        params
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.taskPackageMap[val] = data.data.records;
      this.taskPackageMap = { ...this.taskPackageMap };
    },
    //原接包公司
    async getTenantOperationRelList() {
      const query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ["9901"],
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get`,
        query
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.tenantList = data.data.records || [];
    },
    async getData() {
      const params = {
        ...this.page,
        submitTenantGuid: localStorage.guid,
      };
      params.accountMonth = params.accountMonth?.replace("-", "");
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/task-change/data/page`,
        params
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
      }
      this.tableData = data.data.records;
      this.page.totalPage = data.data.totalPages;
      this.page.totalRows = data.data.totalRows;
    },
    async search() {
      this.page.pageIndex = 1;
      await this.getData();
    },
    emptySearch() {
      this.page = {
        ...this.page,
        pageIndex: 1,
        tenantGuid: "", //企业GUID
        taskGuid: "", //任务包GUID
        changeTenantGuid: "", //接包企业GUID
        changeTaskGuid: "", //接包任务包GUID
        changeTypeList: [], //转换类型 0待处理 1转换中 2转换成功 3转换失败 4撤消中 5撤销成功 6撤销失败
        createUserName: "", //创建人姓名
        accountMonth: "",
      };
      this.taskPackageMap = {};
      this.getData();
    },
    onChangeTenant(val) {
      this.page.tenantGuid = val;
      this.getList(val);
    },
    onChangeNewTenant(val) {
      this.page.changeTenantGuid = val;
      this.getList(val);
    },
    onChangeAccountMonth(val) {
      this.page.accountMonth = val;
      this.getList(this.page.tenantGuid);
      this.getList(this.page.changeTenantGuid);
    },
    // 重试
    async handleRestart(row) {
      const res = await this.$confirm("确定重试吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (!res) {
        return;
      }
      const params = {
        guid: row.guid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.get(
        `/${serverConfig.msSalesPerformService}/task-change/data/restart`,
        params
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
      }
      this.getData();
    },
    // 撤销
    async handleRevoke(row) {
      const res = await this.$confirm("确定撤销吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (!res) {
        return;
      }
      const params = {
        guid: row.guid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.get(
        `/${serverConfig.msSalesPerformService}/task-change/data/cancel`,
        params
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
      }
      this.getData();
    },
    // 只有自己提交的数据才能操作
    isSelfSubmit(row) {
      const userinfo = JSON.parse(localStorage.userInfo);
      return row.createUserId == userinfo.userGuid;
    },
    // 撤销
    showRevokeBtn(row) {
      const isSelfSubmit = this.isSelfSubmit(row);
      // 自己提交的  &&  状态为 转换成功
      if (!isSelfSubmit) {
        return false;
      }
      return ChangeTypeEnum.ConversionSuccess === row.changeType;
    },
    // 重试
    showRestartBtn(row) {
      const isSelfSubmit = this.isSelfSubmit(row);
      // 自己提交的  &&  状态为 转换失败 || 撤销失败
      if (!isSelfSubmit) {
        return false;
      }
      // 可操作的状态
      const isChangeTypeList = [
        ChangeTypeEnum.ConversionFailure,
        ChangeTypeEnum.RevokeFailure,
      ];
      return isChangeTypeList.includes(row.changeType);
    },
    onChangeShowMore() {
      this.showMore = !this.showMore;
      if (this.showMore) {
        this.tableHeight = window.innerHeight - 260;
        return;
      }
      this.tableHeight = window.innerHeight - 210;
    },
  },
  async created() {
    await this.getTenantOperationRelList();
    await this.getData();
  },
};
</script>

<style></style>
